import RequestV2 from './request-v2';

export default class PaymentHttpService {
    private static uri = 'payments';

    public static listPaymentMethods() {
        return RequestV2.get(`${this.uri}`);
    }
}
